import { render, staticRenderFns } from "./AlternativesSort.vue?vue&type=template&id=c32c9bf8&scoped=true&"
import script from "./AlternativesSort.vue?vue&type=script&lang=js&"
export * from "./AlternativesSort.vue?vue&type=script&lang=js&"
import style0 from "./AlternativesSort.vue?vue&type=style&index=0&id=c32c9bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32c9bf8",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg,QIcon,QTooltip,QBtn});
